import { BaseComponentProps } from '@/components/BaseComponentProps';
import { cn } from '@agnes/ui';

export type TableWrapperProps = BaseComponentProps;

export function TableWrapper({ className, children, dataQa }: TableWrapperProps) {
  return (
    <div
      className={cn(
        className,
        'overflow-hidden border border-agnes-border rounded-lg [&>div>div]:max-h-[60vh] [&>div>div]:overflow-auto [&_thead_th]:sticky [&_thead_th]:top-0 [&_thead_th]:z-10 [&_thead_th]:bg-[var(--tp-bg-table-header)]',
      )}
      data-qa={dataQa}
    >
      {children}
    </div>
  );
}
